import { api } from "@/shared/api/axios";
import { unwrap } from "@/shared/api/unwrap";
import type { ApiResponse } from "@/shared/api/types";

interface bookingSessionPayload {
  clinicId: string;
  serviceId?: string;
  professionalId?: string;
  source: string;
}

export const createBookingSession = async (
  payload: bookingSessionPayload,
): Promise<any> => {
  const response = await api.post<ApiResponse<string>>(
    "/booking-sessions",
    payload,
  );
  return unwrap(response.data);
};
